module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1026-88fbdb4c355ef167f080370d4240a7d9.png";